<template>

     <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <li class="nav-item">
          <router-link class="nav-link " to="/company">
            Company
          </router-link>
        </li>

        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">Solutions</span>
          </a>
          <div class="dropdown-menu-inner">
            <router-link
              to="/solutions/overview"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-warning rounded-circle text-white"
              >
                <i class="ni ni-atom"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-warning mb-md-1">Overview</h6>
                <p class="description d-none d-md-inline-block mb-0">
                  We actively operates in the IT and data center industry,
                  providing services with a differentiating touch and
                  uniqueness.
                </p>
              </div>
            </router-link>
            <router-link
              to="/solutions/digitalinfrastructure"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-primary rounded-circle text-white"
              >
                <i class="ni ni-building"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-primary mb-md-1">
                  Digital Infrastructure
                </h6>
                <p class="description d-none d-md-inline-block mb-0">
                  We help organizations of all sizes with building a robust digital infrastructure and developing a broad-based digital workforce.
                </p>
              </div>
            </router-link>
            <router-link
              to="/solutions/digitalsecurity"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-red rounded-circle text-white"
              >
                <i class="fa fa-lock"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-red mb-md-1">Digital Security</h5>
                <p class="description d-none d-md-inline-block mb-0">
                  Developing a security approach that provides 360-degree protection is key and Important.
                </p>
              </div>
            </router-link>
            <router-link
              to="/solutions/cloud"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-info rounded-circle text-white"
              >
                <i class="fa fa-cloud"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Cloud</h5>
                <p class="description d-none d-md-inline-block mb-0">
                 Transform from cost generating centers into strategic service providers and business enablers with our cloud offerings.
                </p>
              </div>
            </router-link>

          </div>
        </base-dropdown>
<!--
        <base-dropdown tag="li" class="nav-item">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Services</span>
          </a>
          <router-link to="/company" class="dropdown-item"
            >24/7 support</router-link
          >
          <router-link to="/company" class="dropdown-item"
            >Data center Services</router-link
          >
        </base-dropdown>
 -->

         <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">Services</span>
          </a>
          <div class="dropdown-menu-inner">
            <router-link
              to="/services/lifecyclemanagement"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-warning rounded-circle text-white"
              >
                <i class="ni ni-atom"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-warning mb-md-1">Lifecycle Management</h6>
                <p class="description d-none d-md-inline-block mb-0">
                  Automation, simplicity and intelligence to track all your assets
                </p>
              </div>
            </router-link>
            <router-link
              to="/services/assetmanagementandsupport"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-primary rounded-circle text-white"
              >
                <i class="fa fa-server"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-primary mb-md-1">
                  Asset Management and Support
                </h6>
                <p class="description d-none d-md-inline-block mb-0">
                  Asset Management offering is added to every maintenance engagement, eliminating the need for internal resources allocated for contract management.
                </p>
              </div>
            </router-link>
            <router-link
              to="/services/integrationandimplementation"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-red rounded-circle text-white"
              >
                <i class="fa fa-link"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-red mb-md-1">Integration and Implementation</h5>
                <p class="description d-none d-md-inline-block mb-0">
                  We offer services on integration and implementation of infrastructure.
                </p>
              </div>
            </router-link>
            <router-link
              to="/services/managedservices"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-info rounded-circle text-white"
              >
                <i class="fa fa-bell"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Managed Services</h5>
                <p class="description d-none d-md-inline-block mb-0">
                 Our managed services address daily IT management needs, enabling your internal IT staff to better focus on strategic initiatives.
                </p>
              </div>
            </router-link>


                        <router-link
              to="/services/relocationservices"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-success rounded-circle text-white"
              >
                <i class="fa fa-bus"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-success mb-md-1">Relocation Services</h5>
                <p class="description d-none d-md-inline-block mb-0">
                 You can depend on our expertise and professionals to plan and execute every relocation project.
                </p>
              </div>
            </router-link>

          </div>
        </base-dropdown>


        <li class="nav-item">
          <router-link class="nav-link " to="/global">
            Global
          </router-link>
        </li>

        <li class="nav-item">
          <router-link class="nav-link " to="/contact">
            Contact
          </router-link>
        </li>
      </ul>
      
              
</template>

<script>
import BaseDropdown from "@/components/BaseDropdown";
import  SocialNavLinks from "./SocialNavLinks";
export default {
    components  :{
        BaseDropdown,SocialNavLinks
    }
}
</script>